/* jshint esversion: 6 */
//
// Sends one Google Analytics event through window.EventAnalytics (defined by
// application/_event_analytics on the Event Website).
//
// Markup contract:
//   div data-controller="analytics-event" data-analytics-event-name-value="registration_step_email"
//     -> tracked once when the element enters the page (frame swaps included)
//   button data-controller="analytics-event" data-analytics-event-name-value="join_click"
//          data-analytics-event-on-value="click" data-action="click->analytics-event#track"
//     -> tracked on click only
//   Optional data-analytics-event-params-value='{"step_outcome":"sent"}' is merged in.
//   Optional data-analytics-event-key-value="registration_state": the same name
//   is not sent twice in a row for that key, so a frame re-rendering the state
//   it already showed (panel reopen, handshake retry) doesn't count again.
//   Optional data-analytics-event-scope-value="platform": Eventene's property
//   only, for events that report on registration rather than on the Event
//   Website. Anything else goes to Eventene and to the organizer's property.
import { Controller } from 'stimulus';

const PLATFORM_SCOPE = 'platform';

export default class extends Controller {
  static values = { name: String, on: String, params: Object, key: String, scope: String };

  connect() {
    if (this.onValue === 'click') return;
    this.track();
  }

  track() {
    const analytics = window.EventAnalytics;
    if (!analytics || !this.nameValue || this._repeatsLast()) return;
    if (this.scopeValue === PLATFORM_SCOPE) {
      // No fallback to track(): a platform-scoped event reaching the
      // organizer's property would be worse than not being counted at all.
      if (typeof analytics.trackPlatform === 'function') analytics.trackPlatform(this.nameValue, this.paramsValue);
      return;
    }
    analytics.track(this.nameValue, this.paramsValue);
  }

  _repeatsLast() {
    if (!this.keyValue) return false;
    window.__analyticsEventLast = window.__analyticsEventLast || {};
    if (window.__analyticsEventLast[this.keyValue] === this.nameValue) return true;
    window.__analyticsEventLast[this.keyValue] = this.nameValue;
    return false;
  }
}
